__turbopack_context__.v({
  "blok-big-title": "yarn-preview-grid-module__jN7a9a__blok-big-title",
  "blok-subtitle": "yarn-preview-grid-module__jN7a9a__blok-subtitle",
  "blok-title": "yarn-preview-grid-module__jN7a9a__blok-title",
  "showMoreWrapper": "yarn-preview-grid-module__jN7a9a__showMoreWrapper",
  "yarnColor": "yarn-preview-grid-module__jN7a9a__yarnColor",
  "yarnDisplayText": "yarn-preview-grid-module__jN7a9a__yarnDisplayText",
  "yarnShowMore": "yarn-preview-grid-module__jN7a9a__yarnShowMore",
  "yarns": "yarn-preview-grid-module__jN7a9a__yarns",
});
